module.exports = __webpack_public_path__ + "res/30-img_bg_l.a42b0af8776cdc27c9faf4a84089407e.png";